export const contactTemplate = {
    text_en:' Contact name',
    text_ukr:' Назва контакта',
    link: 'If that phone, type : "tel:<phone_number>", email: "mailto:<example@timelycode.com>"',
    type: 'phone or email...'
}
